import { render, staticRenderFns } from "./CargoExpenseOccurrenceCrudData.vue?vue&type=template&id=e2e8b45c&scoped=true"
import script from "./CargoExpenseOccurrenceCrudData.vue?vue&type=script&lang=js"
export * from "./CargoExpenseOccurrenceCrudData.vue?vue&type=script&lang=js"
import style0 from "./CargoExpenseOccurrenceCrudData.vue?vue&type=style&index=0&id=e2e8b45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e8b45c",
  null
  
)

export default component.exports